import React from "react";
import { Suspense, useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Loader from "../Layout/Loader";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "../Route/LayoutRoutes";
import Signin from "../Auth/Signin";
import PrivateRoute from "./PrivateRoute";
import { classes } from "../Data/Layouts";
import SSOHandler from "../Auth/SSOHandler";
// import { useFirebaseNotification } from "../Hooks/useFirebaseNotification";

// setup fake backend

const Routers = () => {
  const login = useState(JSON.parse(localStorage.getItem("currentLab")));
  const defaultLayoutObj = classes.find((item) => Object.values(item).pop(1) === "compact-wrapper");
  const layout = localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();
  // useFirebaseNotification();
  useEffect(() => {
    let abortController = new AbortController();
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    return () => {
      abortController.abort();
    };
  }, []);

  return (
      <Suspense fallback={<Loader />}>
        <SSOHandler/>
        <Routes>
          <Route path={"/"} element={<PrivateRoute />}>
            {login ? (
              <>
                <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
                <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
              </>
            ) : (
              ""
            )}
            <Route path={`/*`} element={<LayoutRoutes />} />
          </Route>
          <Route exact path={`${process.env.PUBLIC_URL}/login`} element={<Signin />} />
          {authRoutes.map(({ path, Component }, i) => (
            <Route path={path} element={Component} key={i} />
          ))}
        </Routes>
      </Suspense>
  );
};

export default Routers;

// import React, { Suspense, useEffect, useState } from "react";
// import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
// import Loader from "../Layout/Loader";
// import { authRoutes } from "./AuthRoutes";
// import LayoutRoutes from "../Route/LayoutRoutes";
// import Signin from "../Auth/Signin";
// import ForgotPassword from "../Auth/ForgotPassword"; // Import ForgotPassword component
// import PrivateRoute from "./PrivateRoute";
// import { classes } from "../Data/Layouts";
// import PublicRoute from "./PublicRoutes";

// const Routers = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(
//     Boolean(localStorage.getItem("currentHospitalAdmin"))
//   );

//   const defaultLayoutObj = classes.find(
//     (item) => Object.values(item).pop(1) === "compact-wrapper"
//   );
//   const layout = localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();

//   useEffect(() => {
//     let abortController = new AbortController();
//     console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
//     console.disableYellowBox = true;

//     return () => {
//       abortController.abort();
//     };
//   }, []);
//   useEffect(() => {
//     setIsLoggedIn(Boolean(localStorage.getItem("currentHospitalAdmin")))
//   }, [])


//   return (
//     <BrowserRouter basename={"/"}>
//       <Suspense fallback={<Loader />}>
//         <Routes>
//           {/* Protected Routes */}
//           <Route path="/" element={<PrivateRoute isLoggedIn={isLoggedIn} />}>
//             <Route
//               path="/"
//               element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />}
//             />
//             <Route path="/*" element={<LayoutRoutes />} />
//           </Route>

//           {/* Public Routes using PublicRoute component */}
//           <Route
//             path={`${process.env.PUBLIC_URL}/login`}
//             element={<PublicRoute isLoggedIn={isLoggedIn} element={Signin} />}
//           />
//           <Route
//             path={`${process.env.PUBLIC_URL}/forgot-password`}
//             element={<PublicRoute isLoggedIn={isLoggedIn} element={ForgotPassword} />}
//           />
//           <Route
//             path={`${process.env.PUBLIC_URL}/reset-password/:_id`}
//             element={<PublicRoute isLoggedIn={isLoggedIn} element={ForgotPassword} />}
//           />

//           {/* Additional Auth Routes */}
//           {authRoutes.map(({ path, Component }, i) => (
//             <Route
//               key={i}
//               path={path}
//               element={<PublicRoute isLoggedIn={isLoggedIn} element={Component} />}
//             />
//           ))}
//         </Routes>
//       </Suspense>
//     </BrowserRouter>
//   );
// };

// export default Routers;
